import type { ComboboxInputPropsInterface, ComboboxOptionType } from '@zillow/constellation-10';
import { Combobox, DropdownSelect } from '@zillow/constellation-10';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';
import { TOUR_DURATION_DISPLAY_MAP } from '../../constants';

type TourDurationDropdownSelectProps = {
  tourDuration?: TourDuration;
  handleOptionSelect: (option: ComboboxOptionType) => void;
  disabled?: boolean;
};

const TOUR_DURATION_OPTIONS = Object.entries(TOUR_DURATION_DISPLAY_MAP).map(([value, label]) => ({
  label,
  value: value as TourDuration,
}));

const TourDurationDropdownSelect = ({
  tourDuration,
  handleOptionSelect,
  disabled = false,
}: TourDurationDropdownSelectProps) => {
  return (
    <DropdownSelect
      placeholder="Select tour duration"
      value={tourDuration}
      onOptionSelect={handleOptionSelect}
      options={TOUR_DURATION_OPTIONS}
      disabled={disabled}
      showLabelForValue
      renderInput={(renderProps: ComboboxInputPropsInterface) => {
        const { ref: _ref, ...adornmentPropsWithoutRef } = renderProps;
        return (
          <Combobox.Input
            {...adornmentPropsWithoutRef}
            value={tourDuration ? TOUR_DURATION_DISPLAY_MAP[tourDuration] : ''}
            data-testid="TourDurationDropdownInput"
          />
        );
      }}
      data-testid="TourDurationDropdownSelect"
    />
  );
};

export default TourDurationDropdownSelect;
